import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import NumberFormat from 'react-number-format';

const NumberFormatInput = props => {
  const { inputRef, ...other } = props;
  return (
    <NumberFormat {...other} ref={inputRef} thousandSeparator prefix="$" />
  );
};

NumberFormatInput.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

export class MoneyInput extends Component {
  render() {
    const {
      input,
      meta: { touched, error },
      ...custom
    } = this.props;

    return (
      <FormControl required={custom.required} fullWidth={custom.fullWidth}>
        <InputLabel htmlFor={custom.name}>{custom.label}</InputLabel>
        <Input
          type="text"
          id={custom.name}
          inputComponent={NumberFormatInput}
          {...input}
          {...custom}
        />
        {touched &&
          error && (
            <FormHelperText error id={`${custom.name}-error`}>
              {error}
            </FormHelperText>
          )}
      </FormControl>
    );
  }
}

export default MoneyInput;
